import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@shared/auth';
import { ApprovalStatus } from '@shared/data-access';

export const completeOnBoardingGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const userService = inject(UserService);
  const currentUser = userService.currentUser();

  if (currentUser?.organization?.approvalStatus === ApprovalStatus.Approved) {
    router.navigate(['/']).then();
    return false;
  }

  return true;
};
